import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Amplify } from 'aws-amplify';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { env } from './utils/utils';
import routes from './routes';
import { AppProvider } from './context/appContext';

declare global {
  interface Window {
    Intercom: any;
    google: any;
    gonative: any;
  }
  namespace JSX {
    interface IntrinsicElements {
      'photon-client': any;
      'photon-prescribe-workflow': any;
    }
  }
}

Sentry.init({
  dsn: env('RIVER_SENTRY_DSN'),
  integrations: [new BrowserTracing()],
  environment: env('RIVER_ENV'),
  tracesSampleRate: env('RIVER_ENV') === 'production' ? 0.5 : 1.0,
});

Amplify.configure({
  Auth: {
    identityPoolId: env('RIVER_AWS_IDENTITY_POOL_ID'),
    region: env('RIVER_AWS_REGION'),
  },
  Storage: {
    AWSS3: {
      bucket: env('RIVER_AWS_BUCKET_NAME'),
      region: env('RIVER_AWS_REGION'),
    },
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 40, // 40 seconds
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppProvider>
        <RouterProvider router={createBrowserRouter(routes(queryClient))} />
      </AppProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
